import IMask from 'imask';

const PHONE_MASK = '+{7} (000) 000-00-00';
const PHONE_SELECTOR = '.js-phone-mask';

export class PhoneMask {
  constructor() {
    this.masks = [];
  }

  init() {
    const inputs = document.querySelectorAll(PHONE_SELECTOR);
    if (!inputs.length) return;

    inputs.forEach((input) => this.bindInput(input));
  }

  bindInput(input) {
    const mask = IMask(input, {
      mask: PHONE_MASK,
      lazy: true,
    });

    this.masks.push({ input, mask });
    this.clearError(input);
    this.syncFilled(input, mask);

    input.addEventListener('focus', () => {
      this.clearError(input);
    });

    input.addEventListener('blur', () => {
      if (!mask.unmaskedValue) {
        mask.value = '';
        this.syncFilled(input, mask);
        this.clearError(input);
        return;
      }

      this.syncFilled(input, mask);

      if (!mask.masked.isComplete) {
        this.showError(input);
      } else {
        this.clearError(input);
      }
    });

    input.addEventListener('input', () => {
      this.syncFilled(input, mask);
      if (mask.masked.isComplete) {
        this.clearError(input);
      }
    });

    const form = input.closest('form');
    if (!form || form.dataset.phoneMaskBound) return;

    form.dataset.phoneMaskBound = 'true';
    form.addEventListener(
      'submit',
      (event) => {
        const phoneInputs = form.querySelectorAll(PHONE_SELECTOR);
        let valid = true;

        phoneInputs.forEach((phoneInput) => {
          const entry = this.masks.find((item) => item.input === phoneInput);
          if (!entry || !entry.mask.masked.isComplete) {
            valid = false;
            this.showError(phoneInput);
          }
        });

        if (!valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  syncFilled(input, mask) {
    if (mask.unmaskedValue) {
      input.classList.add('filled');
    } else {
      input.classList.remove('filled');
    }
  }

  showError(input) {
    input.classList.add('error');
    const error = input.parentNode.querySelector('.footer-form-error');
    if (error) error.classList.remove('hidden');
  }

  clearError(input) {
    input.classList.remove('error');
    const error = input.parentNode.querySelector('.footer-form-error');
    if (error) error.classList.add('hidden');
  }
}
